import type { TourRouteCoordinate } from '@/features/tour/tour-route-map-utils'
import type { ITourPoi, ITourTranslation, TourBasicInfoState } from '@/shared/api/types/tour-types'
import { normalizeTourCoordinates } from '@/features/tour/tour-route-map-utils'

/*
 * * VI: Snapshot là chuỗi JSON ổn định của từng section. Form so snapshot hiện tại với snapshot lúc tải/lưu gần nhất để biết section nào "dirty" mà không cần so sánh sâu từng field.
 * * EN: A snapshot is a stable JSON string of one section. The form compares the current snapshot with the one taken at load/last save to tell which section is dirty, without deep field-by-field diffs.
 */

export function buildTourTranslationSnapshot(translations: ITourTranslation[]): string {
  return JSON.stringify(
    translations.map((item) => ({
      language: item.language,
      name: item.name.trim(),
      description: item.description.trim(),
    })),
  )
}

/** Country/province are derived from the destination, so only the fields the user really edits are compared. */
export function buildTourBasicInfoSnapshot(basicInfo: TourBasicInfoState): string {
  return JSON.stringify({
    duration: basicInfo.duration,
    scopeType: basicInfo.scopeType,
    tenantDestinationId: basicInfo.tenantDestinationId,
    ticketLink: basicInfo.ticketLink,
    isFavorite: basicInfo.isFavorite,
  })
}

export function buildTourMediaSnapshot(banner?: string, thumbnail?: string): string {
  return JSON.stringify({
    banner: banner ?? '',
    thumbnail: thumbnail ?? '',
  })
}

export function buildTourCoordinatesSnapshot(coordinates: TourRouteCoordinate[]): string {
  return JSON.stringify(normalizeTourCoordinates(coordinates))
}

/** Order, colour and favourite rank are what the "Save POI changes" button persists. */
export function buildTourPoisSnapshot(pois: ITourPoi[]): string {
  return JSON.stringify(
    pois
      .slice()
      .sort((a, b) => a.order - b.order)
      .map((poi) => ({
        poiId: poi.poiId,
        color: poi.color ?? null,
        favoritePoiRank: poi.favoritePoiRank ?? null,
      })),
  )
}
